//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OrderCompletion",
  data() {
    return {
      orders: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  filters: {
    formatWorkProgress(value) {
      return `${value}%`;
    },
  },
  created() {
    this.getWorkTypeList();
  },
  methods: {
    /**
     * @descripttion: 获取订单完成情况数据
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getWorkTypeList() {
      let params = { orderId: this.orderId };
      this.$http.order.getWorkTypeList(params).then((res) => {
        this.orders = res.data;
      });
    },
  },
};
